module.exports = __webpack_public_path__ + "img/about-2-mobilecompany.73ca8f83.png";